import { AdapterConfig, AdapterEnum } from '../types';
import ZoidWidgetInit from '../components/renderers/ZoidWidgetInit';
import NovaWidgetInit from '../components/renderers/NovaWidgetInit';

export class AdapterSetup {
  private static instance: AdapterSetup;
  adapters: Map<string, any>;

  constructor() {
    if (AdapterSetup.instance) {
      throw new Error('Error - use Singleton.getInstance()');
    }
    this.adapters = new Map();
  }

  configureAdapters(adaptersConfig: AdapterConfig[]): void {
    adaptersConfig.map(adapter => {
      const { type, id } = adapter;
      if (
        type.toUpperCase() === AdapterEnum.ZOID &&
        this.adapters.get(id) === undefined
      ) {
        const ZoidInitComponent = ZoidWidgetInit({
          ...adapter.config,
        });
        this.adapters.set(id, ZoidInitComponent);
      }

      if (
        type.toUpperCase() === AdapterEnum.NOVA &&
        this.adapters.get(id) === undefined
      ) {
        NovaWidgetInit.initialize({
          ...adapter.config,
        });
        this.adapters.set(id, true);
      }
    });
  }

  getInitComponent(id: string): any {
    return this.adapters.get(id);
  }

  static getInstance(): AdapterSetup {
    AdapterSetup.instance = AdapterSetup.instance || new AdapterSetup();
    return AdapterSetup.instance;
  }
}

export default AdapterSetup;
